<app-page-meta pageTitle="finzy - Investment Application"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
  <div class="row d-md-flex">

    <app-lenderleftdiv class="progress-bullets col-sm-4 hidden-xs"></app-lenderleftdiv>

    <div class="progress-bullets-mobile col-xs-12 visible-xs">
      <app-lender-registration-progress-bar></app-lender-registration-progress-bar>
    </div>

    <div class="col-xs-12 col-sm-6 col-sm-offset-1">
      <div class="right-section-content">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
</div>

<app-footer></app-footer>
